<template>
  <ValidationObserver ref="customerForm" v-slot="{ invalid, passes }">
    <v-form rel="customerForm" @submit.prevent="passes(save)">
      <v-card class="elevation-1 mb-6 rounded-lg">
        <v-card-title class="pa-7">
          {{ title }}
        </v-card-title>
        <v-card-text class="pl-7 pr-7 pt-7">
          <v-row>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.postalCode"
                rules="required"
                label="PSČ"
                outlined
                dense
                type="number"
                background-color="white"
                :loading="distributorLoading"
                @input="(event) => loadDistributor(event)"
              />
            </v-col>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model="distributor.name"
                label="Distributor"
                rules="required"
                dense
                outlined
                readonly
                disabled
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model="value.electricityOrder.rateId"
                label="Distribuční sazba"
                rules="required"
                outlined
                dense
                background-color="white"
                :items="rates"
                item-text="name"
                item-value="id"
                :loading="ratesLoading"
                :disabled="disabledWh"
                @change="loadSuppliersAndProducts"
              />
            </v-col>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.circuitBreakerId"
                label="Jistič"
                rules="required"
                outlined
                dense
                background-color="white"
                :items="circuitBreakers"
                item-text="name"
                item-value="id"
                :disabled="disabledWh"
                :loading="circuitBreakersLoading"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" class="py-0 px-6">
              <v-switch v-model="areaFlat" inset dense @change="handleAreaValue">
                <template slot="label">
                  <div style="color: #21262a">
                    {{ areaFlat ? 'Byt' : 'Dům' }}
                  </div>
                </template>
              </v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="areaFlat" cols="12" sm="12" class="py-0 px-5">
              <v-radio-group v-model="value.electricityOrder.areaId" mandatory row>
                <v-radio
                  v-for="item in areaFlats"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </v-radio-group>
            </v-col>
            <v-col v-if="!areaFlat" cols="12" sm="12" class="py-0 px-5">
              <v-radio-group v-model="value.electricityOrder.areaId" mandatory row>
                <v-radio
                  v-for="item in areaHouses"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <v-radio-group v-model="value.electricityOrder.usageIds" mandatory multiple row>
                <v-radio
                  v-for="item in usages"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  :checked="item.active"
                  @click="uncheckUsage(item)"
                />
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <v-radio-group v-model="value.electricityOrder.personId" mandatory row>
                <v-radio
                  v-for="item in persons"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="mt-10">
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model="value.electricityOrder.consumptionHT"
                rules="required"
                type="number"
                outlined
                dense
                label="Vysoký tarif"
                data-cy="surname"
                suffix="kWh"
              />
            </v-col>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VTextFieldWithValidation
                v-if="!singleTariff"
                v-model="value.electricityOrder.consumptionLT"
                rules="required"
                type="number"
                outlined
                dense
                label="Nízký tarif"
                data-cy="surname"
                suffix="kWh"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.currentSupplierId"
                label="Současný dodavatel"
                outlined
                dense
                background-color="white"
                :items="currentSuppliers"
                item-text="name"
                item-value="id"
                :loading="suppliersLoading"
                :disabled="disabledWh"
                @change="(event) => loadCurrentSupplierProduct(event)"
              />
            </v-col>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.currentSupplierProductId"
                label="Současný produkt"
                outlined
                dense
                background-color="white"
                :items="currentSupplierProducts"
                item-text="name"
                item-value="id"
                :disabled="disabledWh"
                :loading="currentSuppliersProductLoading"
                :clearable="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.supplierId"
                label="Nový dodavatel"
                outlined
                dense
                background-color="white"
                :items="suppliers"
                item-text="name"
                item-value="id"
                :loading="suppliersLoading"
                :disabled="disabledWh"
                @change="(event) => loadSupplierProduct(event)"
              />
            </v-col>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.supplierProductId"
                label="Nový produkt"
                outlined
                dense
                background-color="white"
                :items="supplierProducts"
                item-text="name"
                item-value="id"
                :disabled="disabledWh"
                :loading="suppliersProductLoading"
                :clearable="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.ean"
                label="EAN"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VDatePickerWithValidation
                v-model="value.electricityOrder.connectionBegin"
                date-format="dd.MM.yyyy"
                outlined
                dense
                label="Datum připojení"
                data-cy="phone"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.customerTypeName"
                label="Typ zákazníka"
                outlined
                dense
                background-color="white"
                :items="customerTypes"
                item-text="text"
                item-value="name"
                :loading="customerTypesLoading"
                :clearable="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.contractTypeName"
                label="Typ smlouvy"
                outlined
                dense
                background-color="white"
                :items="contractTypes"
                item-text="text"
                item-value="name"
                :loading="contractTypeLoading"
                :clearable="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.renewalPeriodTypeName"
                label="Prolongace"
                outlined
                dense
                rules="required"
                background-color="white"
                :items="renewalPeriodTypes"
                item-text="text"
                item-value="name"
                :loading="renewalPeriodTypeLoading"
                :clearable="true"
              />
            </v-col>
            <v-col
              v-if="value.electricityOrder.renewalPeriodTypeName === 'CERTAIN'"
              cols="12"
              sm="4"
              class="py-0 px-5"
            >
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.renewalPeriod"
                label="Doba"
                outlined
                dense
                :rules="
                  value.electricityOrder.renewalPeriodTypeName === 'CERTAIN' ? 'required' : ''
                "
                :disabled="value.electricityOrder.renewalPeriodTypeName !== 'CERTAIN'"
                background-color="white"
                type="number"
              />
            </v-col>
            <v-col
              v-if="value.electricityOrder.renewalPeriodTypeName === 'CERTAIN'"
              cols="12"
              sm="4"
              class="py-0 px-5"
            >
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.renewalPeriodUnitName"
                label="Jednotka"
                outlined
                dense
                :rules="
                  value.electricityOrder.renewalPeriodTypeName === 'CERTAIN' ? 'required' : ''
                "
                :disabled="value.electricityOrder.renewalPeriodTypeName !== 'CERTAIN'"
                background-color="white"
                :items="renewalPeriodUnits"
                item-text="text"
                item-value="name"
                :loading="renewalPeriodUnitLoading"
                :clearable="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VDatePickerWithValidation
                v-model="value.electricityOrder.contractSigned"
                date-format="dd.MM.yyyy"
                outlined
                dense
                label="Datum podpisu smlouvy"
                data-cy="phone"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VDatePickerWithValidation
                v-model="value.electricityOrder.contractEnd"
                date-format="dd.MM.yyyy"
                outlined
                dense
                label="Datum ukončení smlouvy"
                data-cy="phone"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.contractBonus"
                label="Podpisová prémie"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.contractConcludingTypeName"
                label="Způsob podpisu smlouvy"
                outlined
                dense
                background-color="white"
                :items="contractConcludingTypes"
                item-text="text"
                item-value="name"
                :loading="contractConcludingTypeLoading"
                :clearable="true"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.contractTerminationTypeName"
                label="Způsob ukončení smlouvy"
                outlined
                dense
                background-color="white"
                :items="contractTerminationTypes"
                item-text="text"
                item-value="name"
                :loading="contractTerminationTypeLoading"
                :clearable="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.terminationPeriod"
                label="Výpovědní lhůta"
                outlined
                dense
                background-color="white"
                type="number"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.terminationPeriodTypeName"
                label="Výpovědní lhůta"
                outlined
                dense
                background-color="white"
                :items="terminationPeriodTypes"
                item-text="text"
                item-value="name"
                :loading="terminationPeriodTypeLoading"
                :clearable="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <YesNoAutocomplete
                v-model="value.electricityOrder.refund"
                label="Refundace"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.advanceAmount"
                label="Výše zálohy Kč"
                outlined
                dense
                background-color="white"
                type="number"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.advancePeriodName"
                label="Platba záloh"
                outlined
                dense
                background-color="white"
                :items="advancePeriods"
                item-text="text"
                item-value="name"
                :loading="advancePeriodLoading"
                :clearable="true"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.advanceTypeName"
                label="Způsob platby zálohy"
                outlined
                dense
                background-color="white"
                :items="advanceTypes"
                item-text="text"
                item-value="name"
                :loading="advanceTypeLoading"
                :clearable="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.bankAccountNumber"
                label="Číslo bankovního účtu"
                type="number"
                outlined
                dense
                background-color="white"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.bankCode"
                label="Kód banky"
                type="number"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.sipoNumber"
                label="Číslo SIPO"
                type="number"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.supplierChangeTypeName"
                label="Typ změny dodavatele"
                outlined
                dense
                background-color="white"
                :items="supplierChangeTypes"
                item-text="text"
                item-value="name"
                :loading="supplierChangeTypeLoading"
                :clearable="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityOrder.dataSentenceSupplierId"
                label="Dodavatel - číselník Yello"
                outlined
                dense
                background-color="white"
                :items="dataSentenceSuppliers"
                item-text="name"
                item-value="id"
                :loading="dataSentenceSupplierLoading"
                :clearable="true"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.dataSentenceProduct"
                label="Produkt - číselník Yello"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <YesNoAutocomplete
                v-model="value.electricityOrder.invoicePdf"
                label="Faktura (PDF)"
                outlined
                dense
                background-color="white"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.invoicePdfEmail"
                label="Faktura (PDF) - email"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <YesNoAutocomplete
                v-model="value.electricityOrder.serviceProvideImmediately"
                label="Poskytování služby - okamžitě"
                outlined
                dense
                background-color="white"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityOrder.serviceProvideCity"
                label="Místo služby, odkud zákazník podepisuje"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <YesNoAutocomplete
                v-model="value.electricityOrder.gdpr"
                label="GDPR"
                outlined
                dense
                background-color="white"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <YesNoAutocomplete
                v-model="value.electricityOrder.marketing"
                label="MKT"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-card-title class="px-0 pb-12 pt-7">
            Čestné prohlášení
            <v-spacer></v-spacer>
          </v-card-title>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VDatePickerEditableWithValidation
                v-model="value.electricityOrder.affidavitCustomerDate"
                date-format="dd.MM.yyyy"
                outlined
                dense
                label="Dne"
                data-cy="phone"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <YesNoAutocomplete
                v-model="value.electricityOrder.affidavitCustomerDied"
                label="Zemřel"
                outlined
                dense
                background-color="white"
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <YesNoAutocomplete
                v-model="value.electricityOrder.affidavitCustomerLeft"
                label="Trvale opustil odběrné místo"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-7">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            height="40px"
            min-width="130px"
            color="primary"
            depressed
            :loading="saving"
          >
            Uložit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '@/components/validators/VAutocompleteWithValidation'
import YesNoAutocomplete from '../YesNoAutocomplete.vue'
import VDatePickerEditableWithValidation from '../validators/VDatePickerEditableWithValidation.vue'

export default {
  name: 'OrderElectricityEditForm',
  components: {
    VDatePickerEditableWithValidation,
    YesNoAutocomplete,
    VAutocompleteWithValidation,
  },
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    edit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    saving: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      areaFlats: [
        {
          id: 1,
          name: 'Do 50m2',
        },
        {
          id: 2,
          name: 'Do 80m2',
        },
        {
          id: 3,
          name: 'Nad 80m2',
        },
      ],
      areaHouses: [
        {
          id: 4,
          name: 'Do 90m2',
        },
        {
          id: 5,
          name: 'Do 150m2',
        },
        {
          id: 6,
          name: 'Nad 150m2',
        },
      ],
      areaId: 1,
      areaFlat: true,
      persons: [
        {
          id: 1,
          name: '1-2 osoby',
        },
        {
          id: 2,
          name: '3-4 osoby',
        },
        {
          id: 3,
          name: '5 a více osob',
        },
      ],
      usages: [
        {
          id: 1,
          name: 'Svícení',
          active: false,
        },
        {
          id: 2,
          name: 'Vaření',
          active: false,
        },
        {
          id: 3,
          name: 'Ohřev vody',
          active: false,
        },
        {
          id: 4,
          name: 'Topení',
          active: false,
        },
      ],
      distributors: [
        {
          id: 1,
          name: 'pre',
        },
        {
          id: 2,
          name: 'pre',
        },
        {
          id: 3,
          name: 'pre',
        },
      ],
      distributor: {
        name: null,
      },
      singleTariff: true,
      postalCode: null,
      distributorId: null,
      rates: [],
      circuitBreakers: [],
      suppliers: [],
      supplierProducts: [],
      currentSuppliers: [],
      currentSupplierProducts: [],
      advancePeriods: [],
      advanceTypes: [],
      terminationPeriodTypes: [],
      renewalPeriodTypes: [],
      renewalPeriodUnits: [],
      customerTypes: [],
      contractTypes: [],
      contractConcludingTypes: [],
      contractTerminationTypes: [],
      supplierChangeTypes: [],
      dataSentenceSuppliers: [],
      distributorLoading: false,
      circuitBreakersLoading: false,
      ratesLoading: false,
      suppliersLoading: false,
      suppliersProductLoading: false,
      currentSuppliersProductLoading: false,
      advancePeriodLoading: false,
      advanceTypeLoading: false,
      terminationPeriodTypeLoading: false,
      renewalPeriodTypeLoading: false,
      renewalPeriodUnitLoading: false,
      customerTypesLoading: false,
      contractTypeLoading: false,
      contractConcludingTypeLoading: false,
      contractTerminationTypeLoading: false,
      supplierChangeTypeLoading: false,
      dataSentenceSupplierLoading: false,
    }
  },
  computed: {
    disabledWh() {
      return this.distributor.name == null
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value.electricityOrder.distributor) {
          this.value.electricityOrder.distributorId = this.value.electricityOrder.distributor.id
        }
        if (this.value.electricityOrder.rate) {
          this.value.electricityOrder.rateId = this.value.electricityOrder.rate.id
        }
        if (this.value.electricityOrder.circuitBreaker) {
          this.value.electricityOrder.circuitBreakerId = this.value.electricityOrder.circuitBreaker.id
        }
        if (this.value.electricityOrder.area) {
          this.value.electricityOrder.areaId = this.value.electricityOrder.area.id
        }
        if (this.value.electricityOrder.person) {
          this.value.electricityOrder.personId = this.value.electricityOrder.person.id
        }
        if (this.value.electricityOrder.usages) {
          this.value.electricityOrder.usageIds = this.value.electricityOrder.usages.map((e) => e.id)
        }
        if (this.value.electricityOrder.product) {
          this.value.electricityOrder.supplierId = this.value.electricityOrder.product.supplierId
        }
        if (this.value.electricityOrder.product) {
          this.value.electricityOrder.supplierProductId = this.value.electricityOrder.product.id
        }
        if (this.value.electricityOrder.currentProduct) {
          this.value.electricityOrder.currentSupplierId = this.value.electricityOrder.currentProduct.supplierId
        }
        if (this.value.electricityOrder.currentProduct) {
          this.value.electricityOrder.currentSupplierProductId = this.value.electricityOrder.currentProduct.id
        }
        if (this.value.electricityOrder.advancePeriod) {
          this.value.electricityOrder.advancePeriodName = this.value.electricityOrder.advancePeriod.name
        }
        if (this.value.electricityOrder.advanceType) {
          this.value.electricityOrder.advanceTypeName = this.value.electricityOrder.advanceType.name
        }
        if (this.value.electricityOrder.terminationPeriodType) {
          this.value.electricityOrder.terminationPeriodTypeName = this.value.electricityOrder.terminationPeriodType.name
        }
        if (this.value.electricityOrder.renewalPeriodType) {
          this.value.electricityOrder.renewalPeriodTypeName = this.value.electricityOrder.renewalPeriodType.name
        }
        if (this.value.electricityOrder.renewalPeriodUnit) {
          this.value.electricityOrder.renewalPeriodUnitName = this.value.electricityOrder.renewalPeriodUnit.name
        }
        if (this.value.electricityOrder.customerType) {
          this.value.electricityOrder.customerTypeName = this.value.electricityOrder.customerType.name
        }
        if (this.value.electricityOrder.contractType) {
          this.value.electricityOrder.contractTypeName = this.value.electricityOrder.contractType.name
        }
        if (this.value.electricityOrder.contractConcludingType) {
          this.value.electricityOrder.contractConcludingTypeName = this.value.electricityOrder.contractConcludingType.name
        }
        if (this.value.electricityOrder.contractTerminationType) {
          this.value.electricityOrder.contractTerminationTypeName = this.value.electricityOrder.contractTerminationType.name
        }
        if (this.value.electricityOrder.supplierChangeType) {
          this.value.electricityOrder.supplierChangeTypeName = this.value.electricityOrder.supplierChangeType.name
        }
        if (this.value.electricityOrder.supplierId) {
          this.loadSupplierProduct()
        }
        if (this.value.electricityOrder.currentSupplierId) {
          this.loadCurrentSupplierProduct()
        }
        if (this.value.electricityOrder.circuitBreakerId) {
          this.loadCircuitBreakers()
        }
        this.checkAreaFlat()
      },
    },
  },
  created() {
    this.loadRates()
    this.loadSuppliers()
    this.loadAdvancePeriods()
    this.loadAdvanceTypes()
    this.loadTerminationPeriodTypes()
    this.loadRenewalPeriodTypes()
    this.loadRenewalPeriodUnit()
    this.loadCustomerTypes()
    this.loadContractType()
    this.loadContractConcludingType()
    this.loadContractTerminationType()
    this.loadSupplierChangeType()
    this.loadDataSentenceSupplier()
  },
  methods: {
    ...mapActions({
      getDistributor: 'electricity/getDistributor',
      getCircuitBreaker: 'electricity/getCircuitBreaker',
      getRates: 'electricity/getRates',
      getSuppliers: 'electricity/getSuppliers',
      getSupplierProducts: 'electricity/getSupplierProducts',
      getAdvancePeriods: 'enum/listAdvancePeriods',
      getAdvanceTypes: 'enum/listAdvanceTypes',
      getTerminationPeriodTypes: 'enum/listTerminationPeriodTypes',
      getRenewalPeriodTypes: 'enum/listRenewalPeriodTypes',
      getRenewalPeriodUnit: 'enum/listRenewalPeriodUnit',
      getContractType: 'enum/listContractType',
      getContractConcludingType: 'enum/listContractConcludingType',
      getContractTerminationType: 'enum/listContractTerminationType',
      getSupplierChangeType: 'enum/listSupplierChangeType',
      getDataSentenceSupplier: 'enum/listDataSentenceSupplier',
      listOrderCustomerType: 'enum/listOrderCustomerType',
    }),
    loadDistributor(postalCode) {
      this.value.electricityOrder.distributorId = null
      this.distributor = { name: null }
      if (postalCode.toString().length !== 5) {
        return
      }
      this.distributorLoading = true
      this.getDistributor(postalCode)
        .then((response) => {
          this.distributor = response.data
          this.value.electricityOrder.distributorId = response.data.id
        })
        .finally(() => {
          this.distributorLoading = false
        })
        .catch(() => {})
    },
    loadCircuitBreakers() {
      if (!this.value.electricityOrder.distributorId || !this.value.electricityOrder.rateId) return
      this.circuitBreakersLoading = true
      this.getCircuitBreaker({
        distributorId: this.value.electricityOrder.distributorId,
        rateId: this.value.electricityOrder.rateId,
      })
        .then((response) => {
          this.circuitBreakers = response.data
        })
        .finally(() => {
          this.circuitBreakersLoading = false
        })
    },
    loadRates() {
      this.ratesLoading = true
      this.getRates()
        .then((response) => {
          this.rates = response.data
          this.loadCircuitBreakers()
          this.checkTariff()
        })
        .finally(() => {
          this.ratesLoading = false
        })
    },
    loadSuppliers() {
      this.suppliersLoading = true
      this.getSuppliers()
        .then((response) => {
          this.suppliers = response.data
          this.currentSuppliers = response.data
        })
        .finally(() => {
          this.suppliersLoading = false
        })
    },
    loadSupplierProduct() {
      if (this.value.electricityOrder.supplierId == null) {
        return
      }
      this.suppliersProductLoading = true
      this.getSupplierProducts({
        id: this.value.electricityOrder.supplierId,
        distributorId: this.value.electricityOrder.distributor.id,
        distributionRateId: this.value.electricityOrder.rate.id,
      })
        .then((response) => {
          this.supplierProducts = response.data
        })
        .finally(() => {
          this.suppliersProductLoading = false
        })
    },
    loadCurrentSupplierProduct() {
      if (this.value.electricityOrder.currentSupplierId == null) {
        return
      }
      this.currentSuppliersProductLoading = true
      this.getSupplierProducts({
        id: this.value.electricityOrder.currentSupplierId,
        distributorId: this.value.electricityOrder.distributor.id,
        distributionRateId: this.value.electricityOrder.rate.id,
      })
        .then((response) => {
          this.currentSupplierProducts = response.data
        })
        .finally(() => {
          this.currentSuppliersProductLoading = false
        })
    },
    loadAdvancePeriods() {
      this.advancePeriodLoading = true
      this.getAdvancePeriods()
        .then((response) => {
          this.advancePeriods = response.data
        })
        .finally(() => {
          this.advancePeriodLoading = false
        })
    },
    loadAdvanceTypes() {
      this.advanceTypeLoading = true
      this.getAdvanceTypes()
        .then((response) => {
          this.advanceTypes = response.data
        })
        .finally(() => {
          this.advanceTypeLoading = false
        })
    },
    loadTerminationPeriodTypes() {
      this.terminationPeriodTypeLoading = true
      this.getTerminationPeriodTypes()
        .then((response) => {
          this.terminationPeriodTypes = response.data
        })
        .finally(() => {
          this.terminationPeriodTypeLoading = false
        })
    },
    loadRenewalPeriodTypes() {
      this.renewalPeriodTypeLoading = true
      this.getRenewalPeriodTypes()
        .then((response) => {
          this.renewalPeriodTypes = response.data
        })
        .finally(() => {
          this.renewalPeriodTypeLoading = false
        })
    },
    loadRenewalPeriodUnit() {
      this.renewalPeriodUnitLoading = true
      this.getRenewalPeriodUnit()
        .then((response) => {
          this.renewalPeriodUnits = response.data
        })
        .finally(() => {
          this.renewalPeriodUnitLoading = false
        })
    },
    loadCustomerTypes() {
      this.customerTypesLoading = true
      this.listOrderCustomerType()
        .then((response) => {
          this.customerTypes = response.data
        })
        .finally(() => {
          this.customerTypesLoading = false
        })
    },
    loadContractType() {
      this.contractTypeLoading = true
      this.getContractType()
        .then((response) => {
          this.contractTypes = response.data
        })
        .finally(() => {
          this.contractTypeLoading = false
        })
    },
    loadContractConcludingType() {
      this.contractConcludingTypeLoading = true
      this.getContractConcludingType()
        .then((response) => {
          this.contractConcludingTypes = response.data
        })
        .finally(() => {
          this.contractConcludingTypeLoading = false
        })
    },
    loadContractTerminationType() {
      this.contractTerminationTypeLoading = true
      this.getContractTerminationType()
        .then((response) => {
          this.contractTerminationTypes = response.data
        })
        .finally(() => {
          this.contractTerminationTypeLoading = false
        })
    },
    loadSupplierChangeType() {
      this.supplierChangeTypeLoading = true
      this.getSupplierChangeType()
        .then((response) => {
          this.supplierChangeTypes = response.data
        })
        .finally(() => {
          this.supplierChangeTypeLoading = false
        })
    },
    loadDataSentenceSupplier() {
      this.dataSentenceSupplierLoading = true
      this.getDataSentenceSupplier()
        .then((response) => {
          this.dataSentenceSuppliers = response.data
        })
        .finally(() => {
          this.dataSentenceSupplierLoading = false
        })
    },
    loadSuppliersAndProducts() {
      this.loadCircuitBreakers()
      this.loadSupplierProduct()
      this.loadCurrentSupplierProduct()
      this.checkTariff()
    },
    checkTariff() {
      if (this.rates.length > 0 && this.value.electricityOrder.rateId) {
        this.singleTariff = this.rates.find(
          (rate) => rate.id === this.value.electricityOrder.rateId
        ).single
        return
      }
      this.singleTariff = true
    },
    checkAreaFlat() {
      if (this.value.electricityOrder.areaId) {
        this.areaFlat =
          this.areaFlats.filter((area) => area.id === this.value.electricityOrder.areaId).length > 0
        return
      }
      this.areaFlat = true
    },
    handleAreaValue() {
      if (this.areaFlat) {
        this.value.electricityOrder.areaId = this.areaFlats[0].id
      } else {
        this.value.electricityOrder.areaId = this.areaHouses[0].id
      }
    },
    uncheckUsage(item) {
      item.active = !item.active
      this.value.electricityOrder.usageIds = this.value.electricityOrder.usageIds.filter(
        (value, index) => this.value.electricityOrder.usageIds.indexOf(value) === index
      )
      if (!item.active) {
        const removeIndex = this.value.electricityOrder.usageIds
          .map(function (id) {
            return id
          })
          .indexOf(item.id)

        this.value.electricityOrder.usageIds.splice(removeIndex, 1)
      }
    },
    save() {
      this.$emit('save', this.value)
    },
  },
}
</script>
